import { Link } from "react-router-dom";
import { Mail, FileText, Shield, Info, AlertCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div>
            <h3 className="text-xl font-bold text-[#E5B33E] mb-3" style={{ fontFamily: 'Manrope' }}>
              MudraFX
            </h3>
            <p className="text-sm text-muted-foreground mb-3">
              Real-time currency exchange rates for 150+ currencies worldwide.
            </p>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Mail className="w-4 h-4 text-primary" />
              <a href="mailto:support@mudrafx.app" className="hover:text-primary transition-colors">
                support@mudrafx.app
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-3 uppercase tracking-wider">
              Legal & Policies
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                >
                  <Shield className="w-3.5 h-3.5" />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                >
                  <FileText className="w-3.5 h-3.5" />
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/disclaimer"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                >
                  <AlertCircle className="w-3.5 h-3.5" />
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                >
                  <Info className="w-3.5 h-3.5" />
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Additional Info */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-3 uppercase tracking-wider">
              Data Sources
            </h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a
                  href="https://www.exchangerate-api.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  ExchangeRate-API
                </a>
                <span className="text-xs ml-1">(Live Rates)</span>
              </li>
              <li>
                <a
                  href="https://www.frankfurter.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  Frankfurter API
                </a>
                <span className="text-xs ml-1">(Historical Data)</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
            <p>© {new Date().getFullYear()} MudraFX. All rights reserved.</p>
            <p className="text-xs">
              Built with ❤️ in India | Made with{" "}
              <a
                href="https://emergent.sh"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                Emergent
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
